import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/useAuth";
import { decodeJwt } from "../utils/decodeJwt";

export function PrivateRoute({ children }) {
  const { token } = useAuth();

  const exp = decodeJwt(token)?.exp;
  if (!token || (exp && exp * 1000 <= Date.now())) {
    return <Navigate to="/" replace />;
  }

  return children;
}